import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home')
  },
  {
    path:'*',
    component: () => import('@/views/404')
  },
  {
    path:'/relief',
    component:() => import('@/views/relief')
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({y: 0}),
  routes
})

export default router
